import { Instagram, Mail, Phone } from "lucide-react";
import { CONTACT } from "@/site-data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#2E4390]/60 py-10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-5 md:flex-row md:px-8">
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white p-1">
            <img src="/assets/ecn-logo.png" alt="ECN Dijital" className="h-full w-full object-contain" />
          </span>
          <div>
            <p className="font-syne text-sm font-bold tracking-[0.15em]">
              ECN <span className="text-[#1E7FFF]">DİJİTAL</span>
            </p>
            <p className="font-code text-[9px] tracking-[0.2em] uppercase text-[#8B9AC4]">
              Veri Odaklı Dijital Pazarlama
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center gap-2 text-sm text-[#B9C4E8] md:flex-row md:gap-6">
          <a data-testid="footer-phone-link" href={`tel:+${CONTACT.phoneRaw}`} className="flex items-center gap-2 transition-colors duration-300 hover:text-[#5CA3FF]">
            <Phone size={15} /> {CONTACT.phoneDisplay}
          </a>
          <a data-testid="footer-email-link" href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 transition-colors duration-300 hover:text-[#5CA3FF]">
            <Mail size={15} /> {CONTACT.email}
          </a>
          <a
            data-testid="footer-instagram-link"
            href={CONTACT.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 transition-colors duration-300 hover:text-[#5CA3FF]"
          >
            <Instagram size={15} /> {CONTACT.instagram}
          </a>
        </div>
        <div className="flex flex-col items-center gap-2">
          <p className="font-code text-[10px] tracking-[0.2em] text-[#8B9AC4]">
            © 2026 ECN DİJİTAL — TÜM HAKLARI SAKLIDIR
          </p>
          <a data-testid="footer-admin-link" href="/admin" className="font-code text-[10px] tracking-[0.2em] text-[#8B9AC4]/60 transition-colors hover:text-[#5CA3FF]">
            ADMİN GİRİŞİ
          </a>
        </div>
      </div>
    </footer>
  );
}
